import { createContext, useContext } from 'react';

/**
 * Lets an entry dismiss the menu without every composition threading a setter
 * down to it. Nearly every entry navigates or opens something else, so leaving
 * the popover behind would be wrong in all of them.
 */
export const UserMenuCloseContext = createContext<() => void>(() => {});

export function useUserMenuClose(): () => void {
  return useContext(UserMenuCloseContext);
}
